<mat-toolbar class="top-bar" aria-label="Primary navigation">
  <a routerLink="/" class="brand-link" aria-label="Go to home page">
    <img
      ngSrc="assets/paxi-logo-white.svg"
      width="95"
      height="40"
      priority
      alt="PAXI logo"
      class="brand-logo"
    />
  </a>
</mat-toolbar>
